import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { AxiosError } from 'axios';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useRetryItem = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const retryItem = async (itemId: string) => {
    const response = await Axios.post(`${POST_URL(itemId).retryQueueItem}`);
    return response.data;
  };

  return useMutation<void, AxiosError<BaseError>, string>(retryItem, {
    onSuccess: () => {
      toast.success(t('item-retry-initiated'));
      queryClient.invalidateQueries(['priorityQueue']);
      queryClient.invalidateQueries(['queueSummary']);
    },
    onError: (error: AxiosError<BaseError>) => {
      const errorMessage =
        error.response?.data?.error_description ||
        error.response?.data?.detail ||
        error.response?.data?.error ||
        error.response?.data?.message ||
        t('failed-to-retry-item');
      toast.error(errorMessage);
    }
  });
};
